module.exports = __webpack_public_path__ + "static/media/commonCategoryType.svg";